import React, { useState, useEffect } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { siteData } from '../data';
import { fetchCMSContent } from '../lib/cms';
import { motion } from 'framer-motion';

export default function Contact() {
  const [openingHours, setOpeningHours] = useState([]);
  const formattedPhone = `+45${siteData.phone.replace(/\s/g, '')}`;

  useEffect(() => {
    const loadHours = async () => {
      const data = await fetchCMSContent('opening_hours');
      setOpeningHours(data);
    };
    loadHours();
  }, []);

  return (
    <section id="kontakt" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h2 className="text-3xl font-prata font-medium text-stone-900 mb-8 uppercase tracking-tight">Besøg os i Holbæk</h2>
            <p className="text-lg text-stone-600 mb-12">
              Vi glæder os til at byde dig velkommen i vores hyggelige klinik. Kontakt os for tidsbestilling eller spørgsmål.
            </p>

            <div className="space-y-8">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <MapPin className="w-6 h-6 text-black" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-prata font-medium text-stone-900 uppercase tracking-wide">Adresse</h3>
                  <p className="text-stone-600">{siteData.address}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <Phone className="w-6 h-6 text-black" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-prata font-medium text-stone-900 uppercase tracking-wide">Telefon</h3>
                  <a href={`tel:${formattedPhone}`} className="text-stone-600 hover:text-[#b0a697] transition-colors">
                    {siteData.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <Clock className="w-6 h-6 text-black" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-prata font-medium text-stone-900 uppercase tracking-wide">Åbningstider</h3>
                  <div className="mt-2 space-y-1">
                    {openingHours.map((item) => (
                      <div key={item.id} className="flex justify-between w-64 text-stone-600">
                        <span>{item.day.da}:</span>
                        <span className="font-medium">{item.hours.da}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact CTA (Replaces Form) */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            className="bg-[#ffbd59] p-8 sm:p-12 rounded-3xl shadow-sm text-white relative overflow-hidden flex flex-col justify-center"
          >
            {/* Watermark Logo */}
            <img 
              src="https://assets.auxodev.dk/assets/827bf07b-63d5-4b3e-a53e-0e890a6a1d87/b73d13a3-9cbb-497b-973b-95f80ba16559.png" 
              alt="" 
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-[500px] h-auto opacity-10 pointer-events-none select-none"
            />
            
            <div className="relative z-10">
              <h3 className="text-3xl font-prata font-medium text-white mb-6 uppercase tracking-wide">Tidsbestilling</h3>
              <p className="text-xl mb-4 text-white/90 leading-relaxed">
                For at sikre dig den bedste service og planlægning, håndterer vi udelukkende booking via telefon.
              </p>
              <p className="text-lg font-medium text-white mb-2">
                Ring venligst på følgende telefonnummer:
              </p>
              <a href={`tel:${formattedPhone}`} className="text-3xl font-prata font-bold text-white hover:scale-105 transition-transform duration-300 inline-block mb-8">
                {siteData.phone}
              </a>
                <div className="pt-4">
                  <a
                    href={`tel:${formattedPhone}`}
                    className="inline-flex items-center justify-center px-10 py-4 border border-transparent text-lg font-medium rounded-full text-[#ffbd59] bg-white hover:bg-stone-100 transition-all shadow-lg"
                  >
                    Ring op nu
                    <Phone className="ml-2 w-5 h-5" />
                  </a>
                </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
